import React, { ReactNode, useState } from 'react';
import { IQuestion, ISurvey, Option } from '../interfaces/question.type';
import { SurveyContext } from './SurveyContext';

interface SurveyProviderProps {
	children: ReactNode;
}

export const SurveyProvider: React.FC<SurveyProviderProps> = ({ children }) => {
	const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
	const [selectedOption, setSelectedOption] = useState<Option | null>(null);
	const [completed, setCompleted] = useState<boolean>(false);
	const [response, setResponse] = useState<string>('');
	const [otherResponse, setOtherResponse] = useState<string>('');
	const [survey, setSurvey] = useState<ISurvey | null>(null);
	const [currentQuestion, setCurrentQuestion] = useState<IQuestion | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	return (
		<SurveyContext.Provider
			value={{
				termsAccepted,
				setTermsAccepted,
				selectedOption,
				setSelectedOption,
				completed,
				setCompleted,
				response,
				setResponse,
				otherResponse,
				setOtherResponse,
				survey,
				setSurvey,
				currentQuestion,
				setCurrentQuestion,
				loading,
				setLoading,
			}}
		>
			{children}
		</SurveyContext.Provider>
	);
};
